/**
 * @generated SignedSource<<311c957afd48bb0ead082f5456544ead>>
 * @relayHash 9e9248aaab72f68632f4f93a01114a92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c

import type { ConcreteRequest } from 'relay-runtime';
export type FeedCardActionsMenuQuery$variables = {
  contentId: string;
};
export type FeedCardActionsMenuQuery$data = {
  readonly singleContent: {
    readonly id: string | null;
    readonly metadata: {
      readonly currentuser: {
        readonly favourited: {
          readonly isFavourite: boolean | null;
        } | null;
      } | null;
    };
  } | null;
};
export type FeedCardActionsMenuQuery = {
  response: FeedCardActionsMenuQuery$data;
  variables: FeedCardActionsMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
            "kind": "LinkedField",
            "name": "currentuser",
            "plural": false,
            "selections": [
              {
                "concreteType": "FavouritedSummary",
                "kind": "LinkedField",
                "name": "favourited",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FeedCardActionsMenuQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedCardActionsMenuQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9e9248aaab72f68632f4f93a01114a92",
    "id": "834ab8d6fbb4fc4059da3ccb65130de331623de4c2ed2a519b20592d4498d06c",
    "metadata": {},
    "name": "FeedCardActionsMenuQuery",
    "operationKind": "query",
    "text": "query FeedCardActionsMenuQuery($contentId:ID!){singleContent(id:$contentId){id,metadata{currentuser{favourited{isFavourite}}}}}"
  }
};
})();

(node as any).hash = "5b51ad676490df42bb3f9849e1afbcc7";

export default node;
